import api from '@/api';
import lessonsApi from '@/api/lessons';

const actions = {
  FETCH_LESSONS: async ({ commit, dispatch, state, rootGetters, rootState }) => {
    const { id: userId } = rootGetters.userProfile;

    if (!userId) {
      return;
    }

    const {
      currentPage,
      pageSize,
      filters: {
        level: { max_quantum, min_quantum },
        media_type,
      },
      searchTags,
      searchKeywords,
    } = state;

    let { ordering } = state;

    const offset = currentPage * pageSize;
    let lessonQuery = '';

    if (ordering === '-level_name') {
      ordering = '-min_quantum';
    }
    if (ordering === 'level_name') {
      ordering = 'min_quantum';
    }

    if (searchTags.length) {
      lessonQuery += searchTags.join('+');
    }

    if (searchKeywords) {
      if (searchTags.length) {
        lessonQuery += '+';
      }

      lessonQuery += searchKeywords;
    }

    const params = {
      limit: pageSize,
      offset,
      ordering,
      max_quantum,
      min_quantum,
      media_type,
      lesson_query: lessonQuery ? encodeURIComponent(lessonQuery) : null,
    };

    dispatch('wait/start', 'lessons.fetching', { root: true });

    try {
      const { count, results: lessons } = await lessonsApi.fetchLessonsList(params);

      if (lessons.length > 0) {
        const timeZoneEntry = lessons.find(entry => entry.data_timezone);
        const timeZone = timeZoneEntry ? timeZoneEntry.data_timezone : null;
        const route = rootState.route.name;

        if (timeZone) {
          commit('timezones/SET_ROUTE_TIMEZONE', { route, timeZone }, { root: true });
        }
      }

      commit('SET_LESSONS', lessons);
      commit('SET_TOTAL_COUNT', count);
      commit('SET_REFRESH_DATE', Date.now());
      dispatch('wait/end', 'lessons.fetching', { root: true });
    } catch (error) {
      if (error.name !== 'AbortError') {
        dispatch('wait/end', 'lessons.fetching', { root: true });
        throw error;
      }
    }
  },

  FETCH_LEVELS: async ({ commit, dispatch, rootGetters }) => {
    const { id: organizationId } = rootGetters.userProfile.organization;

    dispatch('wait/start', 'lessons.fetchingLevels', { root: true });

    try {
      const levels = await api.fetchOrganizationLevels(organizationId);

      commit('SET_LEVELS', levels);
    } finally {
      dispatch('wait/end', 'lessons.fetchingLevels', { root: true });
    }
  },

  FETCH_LESSONS_TAGS: async ({ commit, dispatch }) => {
    dispatch('wait/start', 'lessons.fetchingTags', { root: true });

    try {
      const lessonsTags = await lessonsApi.fetchLessonsTagsList();

      commit('SET_LESSONS_TAGS', lessonsTags);
    } finally {
      dispatch('wait/end', 'lessons.fetchingTags', { root: true });
    }
  },

  FETCH_AVAILABLE_FEATURE_GROUPS: async ({ commit, dispatch }) => {
    dispatch('wait/start', 'lessons.fetchingGroups', { root: true });

    try {
      const groups = await api.fetchAvailableFeatureGroups();

      commit('SET_AVAILABLE_FEATURE_GROUPS', groups);
    } finally {
      dispatch('wait/end', 'lessons.fetchingGroups', { root: true });
    }
  },

  CHANGE_ORDERING: ({ commit, dispatch, state }, { ordering }) => {
    if (ordering === state.ordering) {
      return;
    }

    commit('SET_ORDERING', ordering);
    commit('SET_CURRENT_PAGE', 0);
    dispatch('FETCH_LESSONS');
  },

  CHANGE_PAGE_SIZE: ({ commit, dispatch }, { pageSize }) => {
    commit('SET_PAGE_SIZE', pageSize);
    commit('SET_CURRENT_PAGE', 0);
    dispatch('FETCH_LESSONS');
  },

  CHANGE_CURRENT_PAGE: ({ commit, dispatch }, { currentPage }) => {
    commit('SET_CURRENT_PAGE', currentPage);
    dispatch('FETCH_LESSONS');
  },

  APPLY_FILTER: ({ commit, dispatch }, filter) => {
    commit('SET_CURRENT_PAGE', 0);
    commit('SET_FILTER', filter);
    dispatch('FETCH_LESSONS');
  },

  CHANGE_SEARCH_TAGS: ({ commit, dispatch }, tag) => {
    commit('SET_CURRENT_PAGE', 0);
    commit('SET_SEARCH_TAG', tag);
    dispatch('FETCH_LESSONS');
  },

  SEARCH_BY_KEYWORD: ({ commit, dispatch }) => {
    commit('SET_CURRENT_PAGE', 0);
    dispatch('FETCH_LESSONS');
  },

  RESET_FILTERS: ({ commit, dispatch }) => {
    commit('RESET_FILTERS');
    dispatch('FETCH_LESSONS');
  },
};

export default actions;
